import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { store } from "../store/store";

window.Pusher = Pusher;

const chatSocket = new Echo({
  broadcaster: "reverb",
  key: "taskamoon",
  wsHost: "ws.taskamoon.ir",
  wsPort: 80,
  wssPort: 443,
  forceTLS: true,
  enabledTransports: ["ws", "wss"],
  authorizer: (channel) => ({
    authorize: (socketId, callback) => {
      fetch("https://api.taskamoon.ir/broadcasting/auth", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getState().auth.token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          socket_id: socketId,
          channel_name: channel.name,
        }),
      })
        .then((r) => r.json())
        .then((data) => callback(null, data))
        .catch((err) => callback(err));
    },
  }),
});

export let activeRoomId = null;
export const setActiveRoomId = (id) => {
  activeRoomId = id;
};

export default chatSocket;
